enum EDSButtonSize {
  DEFAULT ='default',
  SMALL ='small',
  XXS ='xxs',
}

export default EDSButtonSize;
